import 'mdn-polyfills/NodeList.prototype.forEach';
import Video from './Video';

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.js-video');
  if (!videos.length) {
    return;
  }

  videos.forEach((element) => {
    const video = new Video(element);
    video.mount(element);
  });
});
